import React from 'react'
import BaseDateRangeReport from './BaseDateRangedReport'

export default () => <BaseDateRangeReport
  reportHeader = "Fund Movement Report"
  reportDownloadName = "fundMovementReport"
  apiReportName = "fundMovementReport"
/>
